import { FinalImpactScoreType } from '../../../common/model/output/scores/types';
import { Valence } from '../../../common/model/types';
import { KeysEnum } from '../../../common/utils/types';

export type ModelEntityViewRouteParams = {
  id: string;
  name?: string;
  viewMode?: string;
  resultIdOrInternalViewMode?: string; // OA: I made this old hack explicit to avoid errors.
} & ModelEntityViewDrilldownRouteParams;

// OA: This pseudo-enum enables having one master location for params, to be used when defining routes.
// Maybe it's a bit overkill, but life is.
export const modelEntityViewRouteParamKeys: KeysEnum<ModelEntityViewRouteParams> = {
  id: 'id',
  name: 'name',
  impactCode: 'impactCode',
  valence: 'valence',
  viewMode: 'viewMode',
  resultIdOrInternalViewMode: 'resultIdOrInternalViewMode',
  scoreType: 'scoreType',
};

export type ModelEntityViewDrilldownRouteParams = {
  resultIdOrInternalViewMode?: string;
  impactCode?: string;
  valence?: Valence;
  scoreType?: FinalImpactScoreType.RELATIVE | FinalImpactScoreType.ABSOLUTE;
};

/**
 * These need to be in order for the current links to work. However, at least the "impactCode", "valence", and
 * "scoreType" are no longer in use at least in CompanyView, CompanyGroupView, and PortfolioView --> consider
 * refactoring this to something more sensible.
 */
export function getModelEntityPathCommonOptionalParams(params: KeysEnum<ModelEntityViewRouteParams>): string[] {
  return [
    params.name,
    params.viewMode,
    params.resultIdOrInternalViewMode,
    params.impactCode,
    params.valence,
    params.scoreType,
  ];
}
